import type { StoreId, ResellerId } from "@KassaroAB/shared/types/ids";
import type { RestInvoiceData } from "@KassaroAB/shared/types/invoices/storeInvoice";
import { api } from "../utils/api";
import type { RestResellerInvoiceData } from "@KassaroAB/shared/types/invoices/resellerInvoice";

export const getStoreInvoicesApi = async (
  storeId: StoreId
) => {
  return api.get<RestInvoiceData[]>(`stores/${storeId}/invoices`);
};

export const generateStoreInvoiceApi = async (
  storeId: StoreId
) => {
  return api.post<RestInvoiceData>(`stores/${storeId}/invoices`, {});
};

export const markStoreInvoiceAsSentApi = async (
  storeId: StoreId,
  period: string
) => {
  return api.post<RestInvoiceData>(`stores/${storeId}/invoices/${period}/mark-sent`, {});
};

export const getResellerInvoicesApi = async (
  resellerId: ResellerId
) => {
  return api.get<RestResellerInvoiceData[]>(`resellers/${resellerId}/invoices`);
};

export const generateResellerInvoiceApi = async (
  resellerId: ResellerId
) => {
  return api.post<RestResellerInvoiceData>(`resellers/${resellerId}/invoices`, {});
};

export const markResellerInvoiceAsSentApi = async (
  resellerId: ResellerId,
  period: string
) => {
  return api.post<RestResellerInvoiceData>(`resellers/${resellerId}/invoices/${period}/mark-sent`, {});
};
